import type { IssueChildrenOrderChangedEvent } from '@atlassian/jira-issue-view-model/src/change-type.tsx';
import { cardsMoveSet } from '../../state/actions/cards/move/index.tsx';
import {
	getOrderedCardIdsByCardListId,
	makeGetCardListIdByCardId,
} from '../../state/selectors/cards/index.tsx';
import type { Action, State } from '../../state/types.tsx';

export const updateRankOnChildrenOrderChange = (
	state: State,
	{ issueIds, rankId, isRankAfter }: IssueChildrenOrderChangedEvent['meta'],
): Action | null => {
	const cardOrder = getOrderedCardIdsByCardListId(state);
	const cardListId = makeGetCardListIdByCardId(state)(rankId);

	if (cardListId == null) {
		return null;
	}

	const cardIds = issueIds
		.map((id) => Number(id))
		.filter((id) => (cardOrder[cardListId] || []).includes(id));
	const cardsMoveSetPayload = {
		cardIds,
		cardListId,
		isBetweenLists: false,
		beforeCardId: !isRankAfter ? rankId : null,
		afterCardId: isRankAfter ? rankId : null,
	};

	/** cardIds can be an empty list here depending on cardListId.
	 * This check ensures no optimistic ranking updates is triggered in Backlog when the issue ranked (and surrounding issues) in BENTO children panel are from different sections
	 * e.g. one from backlog and another from a sprint etc.
	 */
	return cardIds.length ? cardsMoveSet(cardsMoveSetPayload) : null;
};
